module.exports = __webpack_public_path__ + "img/電気回路_5_6_4.2c49db95.png";